var console = console || {log: function() {}};

console.log("rev 2019-01-10")




$(document).ready(function(){


	//$(".fancybox").fancybox({
	//	cyclic: true
	//});

	// $('nav .menu-item-has-children').on('click', function(e) {
	// 	console.log(e)
	// 	if ($('.hamburger').is(":visible")) {
	// 		e.preventDefault()
	// 		console.log('prevented default click')
	// 	}
	// })
	
	// if no href, disable click
	$("nav a[href='']").on("click", function(e) {
		console.log('no href, prevented default click')
		e.preventDefault();
	})

	$("nav #menu-mobile-nav .menu-item-has-children").on("click", function(e) {
		$(this).toggleClass('active');
		$(this).siblings().removeClass('active')
	})

	
	// make rollovers
	$("[data-over-src]").hover(function() {
		try {console.log($(this).attr("data-over-src"));} catch (e) {};
		$(this).attr("src", $(this).attr("data-over-src"));
	}, function() {
		$(this).attr("src", $(this).attr("data-out-src"));
	});
	
	// preload rollovers over states
	if ($.loadImages) {
		var rollovers = $("[data-over-src]").get();
		for (i in rollovers) {
		    $.loadImages($(rollovers[i]).attr("data-over-src"));
		}
	}

	$(".hamburger").on("click", function() {
		$("body").toggleClass("mobile-nav-open")
	})
	
	
});


